<template>
  <div v-loading.sync.fullscreen="loading" class="text-left">
    <div>
      <el-form
          class="table-form"
          :model="query"
          inline
          label-width="80px"
          size="small"
          @submit.native.prevent
      >
        <el-form-item class="label-inline" prop="title" label="标题">
          <el-input
              class="inline-input"
              v-model="query.title"
              placeholder="输入标题查询"
              @keyup.enter.native="fetchInfos"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 15px">
      <el-divider><span v-if="!infos.length">暂无数据</span><span v-if="infos.length">共{{ infos.length }}条数据</span>
      </el-divider>
      <div
          v-for="info in infos"
          :key="info.id" style="margin: 5px"
      >
        <concerned-info-card :info="info" @edit="edit" @remove="remove"></concerned-info-card>
      </div>
    </div>
  </div>
</template>
<script>
import ConcernedInfoCard from './ConcernedInfoCard.vue'
import Page from '@/models/Page'
import ConcernedInfo from '@/models/ConcernedInfo'
import ConcernedInfoService from '@/services/concernedInfo/ConcernedInfoService'

export default {
  components: {ConcernedInfoCard},
  data() {
    return {
      query: new ConcernedInfo(),
      infos: [],
      page: new Page(),
      loading: false
    }
  },
  mounted() {
    this.fetchInfos()
  },
  methods: {
    fetchInfos(pageNo) {
      this.loading = true
      if (pageNo !== undefined) {
        this.page.number = pageNo
      }
      ConcernedInfoService.fetchSelfInfos({
        ...this.query,
        ...this.page
      }).then(resp => {
        const data = resp.data
        this.page = new Page(data)
        this.infos = (data.content || []).map(i => new ConcernedInfo(i))
      }).finally(() => {
        this.loading = false
      })
    },
    edit(i) {
      this.$emit('edit', i)
    },
    remove(i) {
      ConcernedInfoService.remove(i.id).then(resp => {
        if (resp.status === 200) {
          this.fetchInfos(0)
          this.$emit('remove', i)
          this.$message.success('操作成功')
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
